import React from 'react'
import { majorScale, InlineAlert, Pane, ListItem } from 'evergreen-ui'
import { UnstyledList } from 'evergreen-draft'
import Notification, { NotificationProps } from './Notification'

function GroupHeader({ children, intent }) {
  return (
    <InlineAlert
      intent={intent}
      background={intent === 'danger' ? 'redTint' : 'blueTint'}
      padding={majorScale(1)}
      paddingLeft={majorScale(2)}
    >
      {children}
    </InlineAlert>
  )
}

interface NotificationsGroupProps {
  id: string
  title: string
  intent?: string
  items: NotificationProps[]
  onNotificationClick: (item: NotificationProps) => void
}

class NotificationsGroup extends React.Component<NotificationsGroupProps> {
  static defaultProps = {
    intent: 'none',
    items: []
  }

  render() {
    const { title, intent, items, onNotificationClick } = this.props

    return (
      <Pane borderTop>
        <GroupHeader intent={intent}>{title}</GroupHeader>
        <UnstyledList>
          {items.map(item => {
            return (
              <ListItem key={item.id} marginY={0}>
                <Notification {...item} borderTop="muted" onClick={() => onNotificationClick(item)} />
              </ListItem>
            )
          })}
        </UnstyledList>
      </Pane>
    )
  }
}

export default NotificationsGroup
